import { Controller } from "@hotwired/stimulus";
import { Scanner, QrCode } from "../plugins/scanner";

// This controller is used for crate trackings: only scanning the QR of the crate.
// the form (or backend) must hold the event type, this controller doesn't know it.

// Connects to data-controller="scanner-crates"
export default class extends Controller {
  static values = {
    readerId: String,
    cratePrefix: String,
  };

  static targets = [
    "feedback",
    "message",
    "form",
    "crateNumber",
    "qrInstructions",
  ];

  connect() {
    const codes = {};

    if (this.cratePrefixValue) {
      codes.qr = new QrCode({ prefix: this.cratePrefixValue });
    }

    this.scanner = new Scanner(this.readerIdValue, codes);

    // Keep a cache to avoid sending 2x the same crate
    this.previousCrateNumber = null;

    this.scan();
  }

  disconnect() {
    this.previousCrateNumber = null;
    this.stop().then(() => (this.scanner = null));
  }

  scan() {
    this.#showQrInstructions();
    this.#scanQrCode();
  }

  async stop() {
    await this.scanner.stop();
  }

  async toggleTorch() {
    await this.scanner.toggleTorch();
  }

  resetForm() {
    if (this.hasFormTarget) {
      this.formTarget.reset();
    }
  }

  #submitForm() {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit();
      this.resetForm();
    }
  }

  #scanQrCode() {
    this.scanner.scan(
      this.scanner.qr,
      async (scannedString) => {
        this.#setSuccess(scannedString);

        const regex = new RegExp(`^${this.cratePrefixValue}`, "i");
        this.crateNumberTarget.value = scannedString.replace(regex, "");

        if (this.crateNumberTarget.value !== this.previousCrateNumber) {
          this.previousCrateNumber = this.crateNumberTarget.value;
          this.#submitForm();
        }
      },
      (decodedResult) => {
        console.debug("invalid qr code:", decodedResult);
      },
    );
  }

  #setSuccess(message) {
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.classList.remove("d-none");

      const wrapper = this.feedbackTarget.querySelector(".feedback");
      if (wrapper) {
        wrapper.classList.remove("error");
        wrapper.classList.add("success");
      }

      const icon = this.feedbackTarget.querySelector(".icon");
      if (icon) {
        icon.innerHTML = '<i class="fa fa-check"></i>';
      }
    }

    if (this.hasMessageTarget) {
      this.messageTarget.textContent = message;
    }
  }

  #showQrInstructions() {
    if (this.hasQrInstructionsTarget) {
      this.qrInstructionsTarget.classList.add("active");
    }
  }
}
